import { render, staticRenderFns } from "./worker.vue?vue&type=template&id=0e073fe8&scoped=true"
import script from "./worker.vue?vue&type=script&lang=js"
export * from "./worker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e073fe8",
  null
  
)

export default component.exports